import { reactive, h } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6adeed60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "module-title"
}, "My orders", -1));
const _hoisted_3 = {
  key: 0,
  class: "load-loading"
};
const _hoisted_4 = {
  class: "order-header"
};
const _hoisted_5 = {
  class: "order-number"
};
const _hoisted_6 = {
  key: 0,
  class: "track-number"
};
const _hoisted_7 = {
  class: "operate-btns"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"order-content-header\" data-v-6adeed60><div class=\"sku-info\" data-v-6adeed60>Product</div><div class=\"details\" data-v-6adeed60><div class=\"price\" data-v-6adeed60>Price</div><div class=\"quantity\" data-v-6adeed60>Quantity</div><div class=\"payment-tim\" data-v-6adeed60>Payment time</div><div class=\"status\" data-v-6adeed60>Status</div></div></div>", 1);
const _hoisted_9 = {
  class: "order-content"
};
const _hoisted_10 = {
  class: "sku-lists"
};
const _hoisted_11 = {
  class: "sku-info"
};
const _hoisted_12 = {
  class: "sku-details"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "sku-info"
};
const _hoisted_15 = {
  class: "details"
};
const _hoisted_16 = {
  class: "price"
};
const _hoisted_17 = {
  class: "quantity"
};
const _hoisted_18 = {
  class: "payment-tim"
};
const _hoisted_19 = {
  class: "status"
};
const _hoisted_20 = {
  class: "order-summary"
};
const _hoisted_21 = {
  class: "order-remarks"
};
const _hoisted_22 = {
  class: "summary-total-infos"
};
const _hoisted_23 = {
  class: "summary-row"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Subtotal:", -1));
const _hoisted_25 = {
  class: "value"
};
const _hoisted_26 = {
  key: 0,
  class: "summary-row"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Coupon saving:", -1));
const _hoisted_28 = {
  class: "value"
};
const _hoisted_29 = {
  class: "summary-row"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Shipping:", -1));
const _hoisted_31 = {
  class: "value"
};
const _hoisted_32 = {
  class: "summary-row"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Total before tax:", -1));
const _hoisted_34 = {
  class: "value"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-row"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Tax:"), /*#__PURE__*/_createElementVNode("span", {
  class: "value"
}, " Free ")], -1));
const _hoisted_36 = {
  class: "summary-row total"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "Total:", -1));
const _hoisted_38 = {
  class: "value"
};
const _hoisted_39 = {
  key: 0,
  class: "bottom-box"
};
import { isEmptyObject, parsePrice } from '@/utils';
import { debounce } from 'lodash';
// State
import { onMounted, ref } from 'vue';
import { getOrderListApi, orderRefund, orderCancel, orderStatusPolling } from '@/api/order';
import useHooks from '@/hooks/common';
import { useRouter, useRoute } from 'vue-router';
import moment from 'moment';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const {
      statusMap,
      statusMapCh,
      statusMapDesc
    } = useHooks();
    const orders = reactive([]); //订单数据
    const loading = ref(true); //加载数据loading
    const pollLoading = ref(false); //轮询loading
    const noMore = ref(false); //是否有更多
    const currentPage = ref(1); //当前页数
    const pageSize = ref(10); //每页多少条
    let orderId = ref(); //订单状态
    const timezoneValue = window.timezone;
    // API call
    const fetchOrders = async page => {
      // try {
      getOrderListApi(pageSize.value, page).then(res => {
        let {
          code,
          data
        } = res;
        if (code === 200) {
          orders.push(...data.records);
          noMore.value = orders.length >= data.total;
          loading.value = false;
          // 订单状态轮询
          if (!isEmptyObject(data.records) && currentPage.value == 1) {
            let pollingOrderObj = data.records.find(item => item.orderId == orderId.value);
            let pollingOrderIndex = data.records.findIndex(item => item.orderId == orderId.value);
            if (pollingOrderObj.status == 1) {
              pollLoading.value = true;
              orderIdPollingStatusRes(pollingOrderIndex);
            }
          }
        }
      }).catch(res => {});
      // } catch (error) {
      //     console.error('Error fetching orders:', error)
      // } finally {
      //     loading.value = false
      // }
    };
    const pollingTimer = ref(null);
    const orderIdPollingStatusRes = async pollingOrderIndex => {
      const poll = async () => {
        try {
          const res = await orderStatusPolling(orderId.value);
          let {
            code,
            data
          } = res;
          // 1支付中 2支付成功 3交易取消
          if (data === 2) {
            if (pollingTimer.value) {
              clearInterval(pollingTimer.value);
              pollingTimer.value = null;
            }
            pollLoading.value = false;
            orders[pollingOrderIndex].status = 2;
          } else if (data === 3) {
            if (pollingTimer.value) {
              clearInterval(pollingTimer.value);
              pollingTimer.value = null;
            }
            pollLoading.value = false;
            orders[pollingOrderIndex].status = 9;
          } else if (data === 1) {
            // 当 data 等于 1 时，确保定时器以 1 秒的间隔运行
            if (!pollingTimer.value) {
              pollingTimer.value = setInterval(poll, 2000);
            }
          }
        } catch (error) {
          console.error('Error polling order status:', error);
        }
      };
      poll();
    };
    const dataCanScroll = ref(false);
    function contentScroll() {
      console.log('contentScroll');
      dataCanScroll.value = true;
    }
    // Infinite scroll handler
    const loadMore = async () => {
      debounce(() => {
        if (!loading.value && !noMore.value) {
          currentPage.value++;
          fetchOrders(currentPage.value);
        }
      }, 300)();
    };
    // Utility functions
    const formatDate = dateString => {
      return new Date(dateString).toLocaleString();
    };
    const calculateTax = amount => {
      return (amount * 0.1).toFixed(2); // 10% tax example
    };
    const calculateTotal = amount => {
      return (amount + Number(calculateTax(amount))).toFixed(2);
    };
    const getStatusButtonClass = order => {
      // Add your status logic here
      return 'status-button';
    };
    const copy = async text => {
      try {
        console.log('text', text);
        await navigator.clipboard.writeText(text);
        ElMessage({
          message: 'copy success!',
          type: 'success'
        });
      } catch (err) {
        ElMessage({
          message: 'copy error!',
          type: 'error'
        });
        console.error(err);
      }
    };
    // 取消订单
    const cancel = item => {
      orderCancel(item.orderId).then(res => {
        ElMessage.success('Order cancelled successfully');
        refreshLists();
      });
    };
    // 去购买
    const buy = item => {
      window.open(item.payUrl);
    };
    // 去退款 todo 还没联调（后端支付回调有问题）
    const refund = item => {
      orderRefund(item.orderId).then(res => {
        let {
          code
        } = res;
        if (code === 200) {
          ElMessage.success('Refund completed');
          refreshLists();
        } else if (code === 10034) {
          ElMessage.warning('The order is non refundable.');
        } else {
          ElMessage.error('Refund failed');
        }
      }).catch(res => {});
    };
    // 联系我们
    const contact = () => {
      console.log('contact');
      ElMessageBox({
        title: 'Contact',
        message: h('p', {
          style: 'color: #757575'
        }, [h('span', null, 'Contact us by email, Our email address is '), h('span', {
          style: 'color: #101010'
        }, 'ticprint@mobvoi.com'), h('span', null, ' , Please feel free to reach out to us, we look forward to hearing from you.')]),
        showCancelButton: true,
        confirmButtonText: 'Done',
        cancelButtonText: 'Cancel'
      });
    };
    const refreshLists = () => {
      orders.splice(0);
      currentPage.value = 1;
      loading.value = true;
      fetchOrders(currentPage.value);
    };
    const previewRef = ref(null);
    const preview = item => {
      if (!item.productData || !item.productData.colorDescription) {
        return false;
      }
      let productData = Object.assign({}, {
        id: item.id
      }, item.productData);
      const arrList = [productData];
      previewRef.value && previewRef.value.itemAllFn('order', arrList, 0);
    };
    // Initial load
    onMounted(() => {
      orderId.value = route.query.orderId;
      fetchOrders(currentPage.value);
    });
    return (_ctx, _cache) => {
      const _component_module_empty = _resolveComponent("module-empty");
      const _component_iconpark_icon = _resolveComponent("iconpark-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_Preview = _resolveComponent("Preview");
      const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(orders).length == 0 ? (_openBlock(), _createBlock(_component_module_empty, {
        key: 0
      })) : _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "order-lists",
        "infinite-scroll-immediate": true,
        "infinite-scroll-delay": 100,
        "infinite-scroll-distance": 200,
        onScrollOnce: contentScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orders), order => {
        return _openBlock(), _createElementBlock("div", {
          key: order.orderId,
          class: "order-card"
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(" Order Number: " + _toDisplayString(order.orderId) + " ", 1), (order.status === 7 || order.status === 8) && order.logisticsInfo.logisticsNo ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(" Tracking Number: " + _toDisplayString(order.logisticsInfo.logisticsNo) + " ", 1), _createVNode(_component_iconpark_icon, {
          class: "copy-icon",
          name: "copy",
          onClick: $event => copy(order.logisticsInfo.logisticsNo)
        }, null, 8, ["onClick"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [order.status == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "default",
          size: "medium",
          onClick: $event => cancel(order),
          class: "operate-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_iconpark_icon, {
            class: "btn-icon",
            name: "cancel"
          }), _createTextVNode(" Cancel ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), order.status == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          size: "medium",
          onClick: $event => buy(order),
          class: "operate-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_iconpark_icon, {
            class: "btn-icon",
            name: "buy"
          }), _createTextVNode(" Buy Now ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), order.status == 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "default",
          size: "medium",
          onClick: $event => refund(order),
          class: "operate-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_iconpark_icon, {
            class: "btn-icon",
            name: "refund"
          }), _createTextVNode(" Refund ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), order.status != 1 && order.status != 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          type: "default",
          size: "medium",
          onClick: _cache[0] || (_cache[0] = $event => contact()),
          class: "operate-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_iconpark_icon, {
            class: "btn-icon",
            name: "contact"
          }), _createTextVNode(" Contact ")]),
          _: 1
        })) : _createCommentVNode("", true)])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.details, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "sku-list",
            key: item.orderId + '_' + item.skuId
          }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
            src: item.sku.productData.threeDimensionalImageUrl || item.sku.productData.imageUrl,
            alt: "Product",
            class: "sku-image",
            "preview-src-list": [item.sku.productData.threeDimensionalImageUrl || item.sku.productData.imageUrl],
            fit: "cover"
          }, null, 8, ["src", "preview-src-list"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("h3", {
            class: "goods-title ellipsis",
            onClick: $event => preview(item.sku)
          }, _toDisplayString(item.sku.productData.imageName), 9, _hoisted_13), _createElementVNode("p", _hoisted_14, _toDisplayString(item.sku.printSizeName) + ", " + _toDisplayString(item.sku.frameName), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, " $" + _toDisplayString(_unref(parsePrice)(item.orgUnitPrice)) + " USD ", 1), _createElementVNode("div", _hoisted_17, _toDisplayString(item.quantity), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item.createTime) + " (" + _toDisplayString(_unref(timezoneValue)) + ") ", 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(statusMap)[item.status]), 1)])]);
        }), 128))])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createTextVNode(_toDisplayString(_unref(statusMapDesc)[order.status]) + " ", 1), order.status == 1 || order.status == 2 || order.status == 6 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_unref(moment)(order.createTime).add(7, 'days').format('MMMM Do, YYYY')), 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, "$" + _toDisplayString(_unref(parsePrice)(order.subTotalAmount)) + " USD", 1)]), order.couponAmount ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createElementVNode("span", _hoisted_28, "-" + _toDisplayString(_unref(parsePrice)(order.couponAmount)) + " USD", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(parsePrice)(order.shippingAmount)) + " USD", 1)]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("span", _hoisted_34, "$" + _toDisplayString(_unref(parsePrice)(order.beforeTaxAmount)) + " USD", 1)]), _hoisted_35, _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("span", _hoisted_38, "$" + _toDisplayString(_unref(parsePrice)(order.amount)) + " USD", 1)])])])]);
      }), 128)), noMore.value && !loading.value && dataCanScroll.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_el_divider, {
        "content-position": "center",
        class: "end-line",
        "border-style": "dashed"
      }, {
        default: _withCtx(() => [_createTextVNode(" No more items ")]),
        _: 1
      })])) : _createCommentVNode("", true)], 32)), [[_directive_infinite_scroll, loadMore]])], 64)), _createVNode(_component_Preview, {
        ref_key: "previewRef",
        ref: previewRef
      }, null, 512)])), [[_directive_loading, pollLoading.value, void 0, {
        fullscreen: true,
        lock: true
      }]]);
    };
  }
});